import React, { useState } from 'react';
import HeroSimple from './components/HeroSimple';
import SearchSimple from './components/SearchSimple';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieSettings from './components/CookieSettings';
import TermsConditions from './components/TermsConditions';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const renderPage = () => {
    switch (currentPage) {
      case 'privacy':
        return <PrivacyPolicy onBack={() => setCurrentPage('home')} />;
      case 'cookies':
        return <CookieSettings onBack={() => setCurrentPage('home')} />;
      case 'terms':
        return <TermsConditions onBack={() => setCurrentPage('home')} />;
      default:
        return (
          <div style={{ minHeight: '100vh', backgroundColor: '#ffffff' }}>
            <HeroSimple />
            <SearchSimple />
            
            {/* Placeholder sections */}
            <section className="section" style={{ padding: '5rem 0', textAlign: 'center', backgroundColor: '#f3f4f6' }}>
              <div className="container">
                <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#111827', marginBottom: '1rem' }}>
                  Site profissional no <span style={{ color: '#fbbf24' }}>Google e ChatGPT</span> - 3 passos
                </h2>
                <p style={{ fontSize: '1.125rem', color: '#4b5563', marginBottom: '3rem' }}>
                  👉 Em 5 minutos, seu cartão de visitas digital está no ar.
                </p>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
                  <div style={{ background: 'white', padding: '2rem', borderRadius: '1rem', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔍</div>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>1. Digite seu nome profissional</h3>
                    <p style={{ color: '#6b7280' }}>Busque pelo seu nome que Beno vai buscar suas informações na internet.</p>
                  </div>
                  
                  <div style={{ background: 'white', padding: '2rem', borderRadius: '1rem', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🤖</div>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>2. Beno cria seu site em 5 min</h3>
                    <p style={{ color: '#6b7280' }}>Site profissional é criado automaticamente com suas informações.</p>
                  </div>
                  
                  <div style={{ background: 'white', padding: '2rem', borderRadius: '1rem', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                    <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>3. Aparece no Google e ChatGPT</h3>
                    <p style={{ color: '#6b7280' }}>Seu site fica visível no Google e ChatGPT para receber mais pacientes.</p>
                  </div>
                </div>
              </div>
            </section>

            {/* Call to action */}
            <section className="section" style={{ padding: '5rem 0', textAlign: 'center', background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #3730a3 100%)', color: 'white' }}>
              <div className="container">
                <h2 style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                  Pronto para aparecer no Google e ChatGPT?
                </h2>
                <p style={{ fontSize: '1.25rem', marginBottom: '2rem', color: '#bfdbfe' }}>
                  Pare de perder pacientes para concorrentes que aparecem no Google e ChatGPT. 
                  <strong> Crie seu site profissional agora mesmo.</strong>
                </p>
                <button 
                  className="btn-primary" 
                  style={{ fontSize: '1.25rem', padding: '1.25rem 3rem' }}
                  onClick={() => {
                    const searchSection = document.querySelector('.search-section');
                    const searchInput = document.querySelector('input[type="text"]');
                    if (searchSection && searchInput) {
                      searchSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      setTimeout(() => {
                        (searchInput as HTMLInputElement).focus();
                      }, 800);
                    }
                  }}
                >
                  <span>✨</span>
                  <span>Crie seu site em 1 clique – 7 dias grátis</span>
                  <span>→</span>
                </button>
              </div>
            </section>

            {/* Footer */}
            <footer style={{ 
              background: '#1f2937', 
              color: '#9ca3af', 
              padding: '2rem 0', 
              textAlign: 'center' 
            }}>
              <div className="container">
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center', 
                  marginBottom: '1rem'
                }}>
                  <div style={{ 
                    fontSize: '1.5rem', 
                    fontWeight: 'bold',
                    color: 'white'
                  }}>
                    Beno
                  </div>
                </div>
                
                <p style={{ fontSize: '0.875rem', marginBottom: '1.5rem' }}>
                  Especialistas em sites para profissionais da saúde
                </p>
                
                {/* Footer Links */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: '2rem', 
                  marginBottom: '1.5rem',
                  flexWrap: 'wrap'
                }}>
                  <button 
                    onClick={() => setCurrentPage('privacy')}
                    className="footer-link"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    Política de privacidade
                  </button>
                  <button 
                    onClick={() => setCurrentPage('cookies')}
                    className="footer-link"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    Configurações de cookies
                  </button>
                  <button 
                    onClick={() => setCurrentPage('terms')}
                    className="footer-link"
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    Termos e condições
                  </button>
                  <a 
                    href="mailto:suporte@beno.com.br"
                    className="footer-link"
                  >
                    Suporte
                  </a>
                </div>
                
                <p style={{ fontSize: '0.75rem', opacity: 0.7 }}>
                  © 2024 Beno. Todos os direitos reservados.
                </p>
              </div>
            </footer>
          </div>
        );
    }
  };

  return renderPage();
}

export default App;